import React from 'react';

// A card with a soft glow that follows the cursor.
const SpotlightCard = ({ as: Tag = 'div', className = '', children, ...rest }) => {
  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--mx', `${e.clientX - rect.left}px`);
    e.currentTarget.style.setProperty('--my', `${e.clientY - rect.top}px`);
  };

  return (
    <Tag className={`card spotlight ${className}`.trim()} onMouseMove={handleMove} {...rest}>
      {children}
    </Tag>
  );
};

export default SpotlightCard;
